var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneNo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 20,
    viewBox: "0 0 85 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4674_57980)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3H19V17H0V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6647 3H19V17H12.6647V3ZM0 3H6.33234V17H0V3Z",
    fill: "#008753"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.289 6.888V9.813H27.429V10.788H30.289V13.713H31.381V10.788H34.241V9.813H31.381V6.888H30.289ZM35.331 14.402V15H41.363V13.96H36.618C36.631 13.492 36.891 13.05 38.217 12.179L39.283 11.503C40.687 10.619 41.493 9.787 41.493 8.396C41.493 6.784 40.427 5.718 38.555 5.718C36.527 5.718 35.461 6.966 35.318 8.89L36.527 8.981C36.618 7.551 37.333 6.758 38.542 6.758C39.712 6.758 40.271 7.473 40.271 8.396C40.271 9.306 39.79 9.93 38.62 10.671L37.541 11.36C35.916 12.4 35.331 13.245 35.331 14.402ZM46.0591 15.182C47.8791 15.182 49.1141 14.246 49.1141 12.517C49.1141 11.139 48.3601 10.45 47.2291 10.307C48.2041 10.06 48.9711 9.371 48.9711 8.175C48.9711 6.797 47.9441 5.718 46.0461 5.718C44.1221 5.718 42.9781 6.849 42.7831 8.669L44.0051 8.747C44.0961 7.473 44.7201 6.758 46.0331 6.758C47.0731 6.758 47.7881 7.2 47.7881 8.292C47.7881 9.345 47.1381 9.904 45.8381 9.904H45.0971V10.84H45.8511C47.2681 10.84 47.9051 11.373 47.9051 12.452C47.9051 13.661 47.0991 14.142 46.0461 14.142C44.7591 14.142 44.0701 13.414 43.9791 11.945L42.7831 12.01C42.8871 14.077 44.0571 15.182 46.0591 15.182ZM50.0741 12.257H54.6111V15H55.8071V12.257H57.0031V11.269H55.8071V5.9H54.1821L50.0741 11.23V12.257ZM51.3741 11.269L54.6111 6.914V11.269H51.3741Z",
    fill: "#080917"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4674_57980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 12.6667L73 8.66669H81L77 12.6667Z",
    fill: "#080917"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4674_57980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 14,
    fill: "white",
    transform: "translate(0 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4674_57980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(69 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNo);
export default __webpack_public_path__ + "static/media/phone_no.dacf039706f7f05ee7022e0849732226.svg";
export { ForwardRef as ReactComponent };